import { Text } from "@/design-system";
import { PageSection } from "@/pages/landingPage/components/pageSection";
import { clients } from "@/pages/landingPage/utils/clients";

type ProofStripProps = {
  title: string;
  clientNames: string[];
};

/**
 * Faixa de logos estática (sem marquee): carrossel automático pesa no
 * desempenho e na leitura, e o blueprint o descarta.
 */
export const ProofStrip = ({ title, clientNames }: ProofStripProps) => {
  const logos = clientNames.flatMap(name => {
    const client = clients.find(item => item.name === name);
    return client ? [client] : [];
  });

  return (
    <PageSection labelledBy="prova-title" className="flex flex-col gap-6">
      <Text
        as="h2"
        id="prova-title"
        size="small"
        tone="subtle"
        weight="medium"
        className="text-center"
      >
        {title}
      </Text>
      <ul className="grid grid-cols-2 items-center gap-x-6 gap-y-4 sm:grid-cols-3 lg:grid-cols-6">
        {logos.map(client => (
          <li key={client.name} className="flex justify-center">
            <img
              src={client.logo}
              alt={client.name}
              width={120}
              height={60}
              loading="lazy"
              className="h-12 w-28 object-contain opacity-70 grayscale"
            />
          </li>
        ))}
      </ul>
    </PageSection>
  );
};
